// @flow
import * as React from 'react';
import {useEffect} from 'react';
import ReactDOM from 'react-dom';
import IntegrationCheckerRunner from './data/IntegrationCheckerRunner';
import IntegrationCheckerDataFetcher from './IntegrationCheckerDataFetcher';
import IntegrationCheckersSection from './components/IntegrationCheckersSection';

import createInlineChecker from './createInlineChecker';

export type GlobalsProps = {
  dashboardUrl: string,
  currentMerchant: ?string,
  siteUrl: string,
  integrationCheck: string,
  inlineCheckersScenario: ?string,
  inlineCheckers: ?string,
  redirectUrl: string,
};

export function IntegrationCheckers(globals: GlobalsProps): React.Node {
  const {
    dashboardUrl,
    currentMerchant,
    siteUrl,
    integrationCheck,
    inlineCheckers,
    inlineCheckersScenario,
    redirectUrl,
  } = globals;

  // TODO render these directly too
  useEffect(() => {
    // Inline checkers are defined by passing details to the integration_checkers.erb partial
    if (inlineCheckersScenario && inlineCheckers && currentMerchant) {
      const inlineCheckerTestScenarios = inlineCheckers.split(',');
      const inlineRunner = new IntegrationCheckerRunner();

      inlineCheckerTestScenarios.forEach((testScenario) => {
        const container = document.getElementById(
          `${testScenario}-integration-checkers-react-container`,
        );

        if (container) {
          createInlineChecker(
            inlineRunner,
            inlineCheckersScenario,
            testScenario,
            container,
            globals,
          );
        }
      });
    }
  }, [currentMerchant, inlineCheckers, inlineCheckersScenario]);

  return (
    <IntegrationCheckerDataFetcher
      runner={new IntegrationCheckerRunner()}
      startPolling={false}
      globals={globals}
      loadOnInit={!!currentMerchant}
    >
      {({runCheckerResult, loadingCheckers, runCheckers, error}) => (
        <IntegrationCheckersSection
          results={runCheckerResult.results.filter(
            (result) =>
              result.type !== 'accept_a_payment_payment_succeeds_inline',
          )}
          dashboardUrl={dashboardUrl}
          currentMerchant={currentMerchant}
          siteUrl={siteUrl}
          loginCTARedirectTarget={redirectUrl}
          error={error}
          loadingCheckers={loadingCheckers}
          runCheckers={() => runCheckers(integrationCheck, 3)}
          integrationCheckerName={globals.integrationCheck}
        />
      )}
    </IntegrationCheckerDataFetcher>
  );
}

const initIntegrationCheckers = (props: GlobalsProps) => {
  const domContainer = document.getElementById(
    'integration-checkers-react-container',
  );

  if (!domContainer) {
    return null;
  }

  // Render main app outside of polling logic
  ReactDOM.render(<IntegrationCheckers {...props} />, domContainer);
};

export {initIntegrationCheckers};
